export default __webpack_public_path__ + "static/media/patient.92e57f98.png";